import React from 'react';
import { ReactComponent as ClockIcon } from 'app/assets/img/icon-clock-countdown.svg';
import { parseSecondsToMinutesAndHours } from 'utils/time';
import * as _ from 'lodash';
interface CountdownProps {
  time: number;
}

const Countdown = (props: CountdownProps) => {
  const { time } = props;
  const { hours, minutes, seconds } = parseSecondsToMinutesAndHours(
    time / 1000,
  );
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        background: '#FFDDC9CC',
        borderRadius: 20,
        minWidth: 148,
        height: 36,
        padding: '8px 16px',
        boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.05)',
      }}
    >
      <ClockIcon />
      <span
        style={{
          fontWeight: 600,
          fontSize: 18,
          color: '#FF7A00',
          marginLeft: 9,
          minWidth: 88,
          display: 'inline-block',
        }}
      >
        {_.isInteger(time) &&
          `${hours < 10 ? '0' + hours : hours}:${
            minutes < 10 ? '0' + minutes : minutes
          }:${seconds < 10 ? '0' + seconds : seconds}`}
        {!_.isInteger(time) && `--:--:--`}
      </span>
    </div>
  );
};

export default Countdown;
